import EventEmitter from 'eventemitter3';
export class MessageDecrypterWrapper extends EventEmitter {
    worker;
    constructor() {
        super();
        console.log('MessageDecrypterWrapper constructor');
    }
    decrypt(streamMessage) {
        this.worker?.postMessage({
            type: 'decrypt',
            data: streamMessage,
        });
    }
    startWorker(aesKey) {
        return new Promise((resolve, _reject) => {
            this.worker = new Worker(new URL('./workers/messagedecrypter.worker.ts', import.meta.url));
            this.worker.onmessage = (e) => {
                const { type, data } = e.data;
                switch (type) {
                    case 'decryptedData':
                        this.emit('decryptedData', data.data, data.streamMessage);
                        break;
                    case 'initCompleted':
                        resolve();
                        break;
                }
            };
            this.worker.postMessage({
                type: 'init',
                data: {
                    aesKey,
                },
            });
        });
    }
    async init(aesKey) {
        try {
            console.log('Starting MessageDecrypterWorker');
            await this.startWorker(aesKey);
        }
        catch (e) {
            console.log('MessageDecrypterWorker::start error', e);
        }
    }
}
